import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useScrollDirection } from '../hooks/useScrollDirection'
import { NavItem, NavChild } from '../types/nav'

export default function Navbar() {
  const isVisible = useScrollDirection()
  const [hoveredItem, setHoveredItem] = useState<string | null>(null)
  const [clickedItem, setClickedItem] = useState<string | null>(null)
  const location = useLocation()

  const handleLogoClick = (e: React.MouseEvent) => {
    if (location.pathname === '/') {
      e.preventDefault()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  const handleItemClick = (label: string) => {
    // On mobile, toggle the clicked item
    if (window.innerWidth < 768) {
      setClickedItem(clickedItem === label ? null : label)
    }
  }

  const navItems: NavItem[] = [
    {
      label: 'Donar',
      children: [
        { label: 'Donaciones', path: '/donar' },
      ]
    },
    {
      label: 'Nosotros',
      children: [
        { label: 'Historia', path: '/nosotros/historia' },
        { label: 'Equipo', path: '/nosotros/equipo' },
        { label: 'Autores', path: '/autor' },
        { label: 'Blog', path: '/blog' }
      ]
    },
    {
      label: 'Ayuda',
      children: [
        { label: 'Inscripciones', path: '/inscripciones' },
        { label: 'Servicios Escolares', path: '/servicios' }
      ]
    },
    {
      label: 'Sé Parte',
      path: '/se-parte'
    }
  ]

  return (
    <>
      <nav 
        className={`fixed top-0 left-0 right-0 bg-[#F7F7F7] z-50 h-16 border-b border-gray-200 transition-transform duration-300 ${
          isVisible ? 'translate-y-0' : '-translate-y-full'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-4 h-full flex items-center justify-between">
          {/* Left side navigation items */}
          <div className="flex items-center space-x-8">
            {navItems.map((item) => (
              <div
                key={item.label}
                className="relative group"
                onMouseEnter={() => window.innerWidth >= 768 && setHoveredItem(item.label)}
                onMouseLeave={() => window.innerWidth >= 768 && setHoveredItem(null)}
                onClick={() => handleItemClick(item.label)}
              >
                {item.path ? (
                  <Link 
                    to={item.path}
                    className="text-black hover:text-gray-600 transition-colors duration-300"
                  >
                    {item.label}
                  </Link>
                ) : item.children ? (
                  <button
                    className="text-black hover:text-gray-600 transition-colors duration-300 bg-transparent border-none p-0 m-0"
                  >
                    {item.label}
                  </button>
                ) : (
                  <span className="text-black cursor-default">
                    {item.label}
                  </span>
                )}
                
                {/* Invisible gap for mouse movement */}
                <div className="absolute h-3 w-full hidden md:block" />
                
                {/* Dropdown Menu */}
                {item.children && ((window.innerWidth >= 768 && hoveredItem === item.label) || (window.innerWidth < 768 && clickedItem === item.label)) && (
                  <div className="absolute top-full left-0 py-2 bg-white rounded-lg shadow-lg min-w-[200px]">
                    {item.children.map((child: NavChild) => (
                      <Link
                        key={child.label}
                        to={child.path}
                        className="block px-4 py-2 text-black hover:text-gray-600 transition-colors duration-300"
                        onClick={() => setClickedItem(null)} // Close dropdown after clicking a link on mobile
                      >
                        {child.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Logo on the right */}
          <Link 
            to="/" 
            className="flex items-center"
            onClick={handleLogoClick}
          >
            <img 
              src="/images/logo/lagaviota-logo.png" 
              alt="La Gaviota" 
              className="h-8"
            />
          </Link>
        </div>
      </nav>
    </>
  )
} 